/* Edit case */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FaEdit, FaTrash, FaBan, FaTimes, FaInfoCircle, FaFileExport, FaChevronDown, FaChevronUp, FaCopy, FaCalendarAlt, FaCloudUploadAlt} from "react-icons/fa";
import "./CaseEntries.css";
import Modal from "react-responsive-modal";
import {
	requestPageOfCases,
	getCommissionInfoBtId,
	getCaseNotesById
} from "../../CaseSelector/store/actions";
import { requestPageOfAdminCases } from "../../Admin/store/action";
import { requestPageOfCommission } from "../../Admin/store1/action";
import axios from "axios";
import { apiUri } from "../../../config";
import { NotificationManager } from "react-notifications";
import DatePicker from "react-datepicker";
import {
	padCalendar,
	numberWithCommas,
	allowAlphaNumeric,
	onlyNumeric
} from "../../../util";
import DisclosureModal from "../../../commissions/components/DisclosureModal";

import Select from 'react-select';
import { Button } from "../../../common/components/Button";
import styled from "styled-components";
import Disclosure from "../Disclosure";
import DisclosureDatesComponent from "../../../common/components/DisclosureDates/DisclosureDatesComponent";
import Sec11DisclosureDatesComponent from "../../../common/components/DisclosureDates/Sec11DisclosureDatesComponent";
import RiskToolDisclosure from '../../../ace/Disclosure';

const ButtonHolder = styled.div`
	margin-top: 10px;
`;

const LeftSideButton = styled(Button)`
	float: right;
`;

const state = {
	className: "CaseSelectorEntry"
};

const integerRegrex = /^[0-9]*$/;
const aphabetnumberRegex = /^[a-zA-Z0-9]*$/;

class CaseEntries extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
			caseDataArray: [],
			currentCases: [],
			sortValue: "",
			sortOrder: "",
			caseData: {},
			className: "CaseSelectorEntry",
			isAdminToken: false,
			open: false,
			heading: "",
			EditCaseData: {},
			openDelete: false,
			openHide: false,
			openCaseNotes: false,
			openBlock: false,
			deleteModalData: {},
			hideModalData: {},
			fillingNameError: "",
			classPeriodStartError: "",
			classPeriodEndError: "",
			nextTradingDayError: "",
			fillingDateError: "",
			tickerError: "",
			docketIdError: "",
			issCaseIdError: "",
			sicCodeError: "",
			cikError: "",
			marketError: "",
			docketNotesError:"",
			settlementValueError:"",
			caseFileError: "",
			amendClaimsError: "",
			indexListIdError:"",
			identifierError: "",
			enableView: false,
			enableCMView: false,
			enableCommission: false,
			amendClaimsList: [],
			ruleTypeList: [],
			settlementStatusList: [],
			indexList: [],
			CommissionInfo: false,
			corrective_events: [],
			caseNotesId: null,
			txtCaseNotes: "",
			importStatus: "",
			blockIssUpdates: "",
			selectedCaseId : null,
			openCalendarModal: false,
			openSec11CalendarModal: false,
			disclosureDates : [],
			popupType: "",
		};
		this.handleEdit = this.handleEdit.bind(this);
		this.handleNotes = this.handleNotes.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleHide = this.handleHide.bind(this);
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleSaveCase = this.handleSaveCase.bind(this);
		this.createRisk = this.createRisk.bind(this);
		this.goToCases = this.goToCases.bind(this);
		this.togglePopup = this.togglePopup.bind(this)
	}

	goToCases(id) {
		sessionStorage.setItem('DANDO',false);
		if (
			this.state.routeName === "/cases" ||
			this.state.routeName === "/CaseManagement"
		) {
			this.props.history.push("/cases/" + id);
		} else if (
			this.state.routeName === "/CustomCaseManagement" &&
			id !== null &&
			id !== undefined
		) {
			this.props.history.push("/cases/" + id);
		} else if (
			this.state.routeName === "/CustomCaseManagement" &&
			id === null
		) {
			this.props.history.push("/cases/0");
		}
	}
	createRisk(risk_id) {
		this.props.history.push("/dandos/create/" + risk_id);
	}
	handleSaveCase(data, actionType) {
		let status = true;

		if (
			!this.state.EditCaseData.fillingName ||
			this.state.EditCaseData.fillingName.trim() === ""
		) {
			status = false;
			this.setState({
				fillingNameError: "Filing Name required!"
			});
		} else {
			this.setState({ fillingNameError: "" });
		}

		if (
			!this.state.EditCaseData.classPeriodStart ||
			this.state.EditCaseData.classPeriodStart === ""
		) {
			status = false;
			this.setState({
				classPeriodStartError: "Class Period Start Date required!"
			});
		} else {
			this.setState({ classPeriodStartError: "" });
		}

		if (
			!this.state.EditCaseData.classPeriodEnd ||
			this.state.EditCaseData.classPeriodEnd === ""
		) {
			status = false;
			this.setState({
				classPeriodEndError: "Class Period End Date required!"
			});
		} else {
			this.setState({ classPeriodEndError: "" });
		}

		if (
				this.state.EditCaseData.nextTradingDay &&
				this.state.EditCaseData.nextTradingDay.length > 0 &&
				isNaN(Date.parse(this.state.EditCaseData.nextTradingDay) )
		) {
			status = false;
			this.setState({
				nextTradingDayError: "If next trading day is included, it must be a valid date!"
			});
		} else {
			this.setState({ nextTradingDayError: "" });
		}

		if (!this.state.enableCommission) {
			if (
				!this.state.EditCaseData.fillingDate ||
				this.state.EditCaseData.fillingDate === ""
			) {
				status = false;
				this.setState({
					fillingDateError: "Filing Date required!"
				});
			} else {
				this.setState({ fillingDateError: "" });
			}
		}

		if (
			!this.state.EditCaseData.ticker ||
			this.state.EditCaseData.ticker.trim() === ""
		) {
			status = false;
			this.setState({
				tickerError: "Ticker required!"
			});
		} else {
			if (!aphabetnumberRegex.test(this.state.EditCaseData.ticker)) {
				status = false;
				this.setState({
					tickerError: "Enter only alphanumeric characters"
				});
			} else {
				this.setState({ tickerError: "" });
			}
		}

		if (
			!this.state.EditCaseData.identifier ||
			this.state.EditCaseData.identifier.trim() === ""
		) {
			status = false;
			this.setState({
				identifierError: "Identifier required!"
			});
		} else {
			if (!aphabetnumberRegex.test(this.state.EditCaseData.identifier)) {
				status = false;
				this.setState({
					identifierError: "Enter only alphanumeric characters"
				});
			} else {
				this.setState({ identifierError: "" });
			}
		}

		if (
			!this.state.enableCommission &&
			(!this.state.EditCaseData.docketId ||
				!this.state.EditCaseData.docketId.match(/^\d{2,2}-[a-z]{2,2}-\d{1,5}$/))
		) {
			status = false;
			this.setState({
				docketIdError: "Valid docket number required! (YY-cv-#####)"
			});
		} else {
			this.setState({ docketIdError: "" });
		}

		if (
			!this.state.enableCommission &&
			(	
				this.state.EditCaseData.issCaseId != null &&
				this.state.EditCaseData.issCaseId.toString().trim() !== "" &&
				!integerRegrex.test(this.state.EditCaseData.issCaseId)
			)
		) {
			status = false;
			this.setState({
				issCaseIdError: "If ISS Case Id is included, it must be an integer"
			});
		} else {
			this.setState({ issCaseIdError: "" });
		}

		if (
			!this.state.EditCaseData.sicCode ||
			this.state.EditCaseData.sicCode === ""
		) {
			status = false;
			this.setState({
				sicCodeError: "SIC Code required!"
			});
		} else {
			if (!integerRegrex.test(this.state.EditCaseData.sicCode)) {
				status = false;
				this.setState({
					sicCodeError: "Enter only numbers"
				});
			} else {
				this.setState({ sicCodeError: "" });
			}
		}

		if (
			!this.state.EditCaseData.cik ||
			this.state.EditCaseData.cik === ""
		) {
			status = false;
			this.setState({
				cikError: "CIK required!"
			});
		} else {
			if (!integerRegrex.test(this.state.EditCaseData.cik)) {
				status = false;
				this.setState({
					cikError: "Enter only numbers"
				});
			} else {
				this.setState({ cikError: "" });
			}
		}		

		if (
			!this.state.enableCommission &&
			(!this.state.EditCaseData.market ||
				this.state.EditCaseData.market.trim() === "")
		) {
			status = false;
			this.setState({
				marketError: "Market required!"
			});
		} else {
			this.setState({ marketError: "" });
		}
		if (
			!this.state.enableCommission &&
				this.state.EditCaseData.settlementStatusId === 2 &&
			(!this.state.EditCaseData.settlementValue ||
				isNaN(this.state.EditCaseData.settlementValue) )

		) {
			status = false;
			this.setState({
				settlementValueError: "Settlement Value required!"
			});
		} else {
			this.setState({ settlementValueError: "" });
		}
		if (
			!this.state.EditCaseData.indexListId ||
				isNaN(this.state.EditCaseData.indexListId)
		) {
			status = false;
			this.setState({
				indexListIdError: "Must Select an industry index!"
			});
		} else {
			this.setState({ indexListIdError: "" });
		}
		if ( !this.state.enableCommission && (
			!this.state.EditCaseData.amendClaims ||
				isNaN(this.state.EditCaseData.amendClaims))
		) {
			status = false;
			this.setState({
				amendClaimsError: "Must Select a claim life Cycle!"
			});
		} else {
			this.setState({ amendClaimsError: "" });
		}
		if (
			!this.state.EditCaseData.caseFile ||
			this.state.EditCaseData.caseFile.trim() === ""
		) {
			status = false;
			this.setState({
				caseFileError: "Case File required!"
			});
		} else {
			this.setState({ caseFileError: "" });
		}

		if (status) {
			this.props.handleSaveFileData(data, actionType);
			this.setState({ open: false });
			if (this.state.enableCommission) {
						this.props.requestPageOfCommission(
							this.props.currentPage,
							this.state.sortValue,
							this.state.sortOrder
						);
			} else if (this.state.routeName === "/CaseManagement") {
				this.props.requestPageOfAdminCases(
					this.props.currentPage,
					this.state.sortValue,
					this.state.sortOrder
				);
			} else {
				this.props.requestPageOfCases(
					this.props.currentPage,
					this.state.sortValue,
					this.state.sortOrder
				);
			}
		} else {
			return false;
		}
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps && nextProps.cases) {
			if (this.state.isAdminToken && this.state.routeName === "/cases") {
				this.setState({ enableView: true });
			}
			nextProps.cases.forEach(element => {
				element.enableEdit = false;
				element.fillingDate_UI = element.fillingDate;
				element.classPeriodStart_UI = element.classPeriodStart;
				element.classPeriodEnd_UI = element.classPeriodEnd;
				element.nextTradingDay_UI = element.nextTradingDay;
			});
			this.setState({ caseDataArray: nextProps.cases });
			if (this.state.routeName === "/CustomCaseManagement") {
				this.setState({ enableCommission: true });
			}
			if (
				this.state.isAdminToken &&
				this.state.routeName === "/CaseManagement"
			) {
				this.setState({ enableCMView: true });
			}
		}
	}
	componentWillMount() {
		let state = this.state;
		state.caseDataArray = this.props.cases;

		state.caseDataArray.forEach(element => {
			element.enableEdit = false;
			element.classPeriodStart_UI = element.classPeriodStart;
			element.classPeriodEnd_UI = element.classPeriodEnd;
			element.nextTradingDay_UI = element.nextTradingDay;
			element.fillingDate_UI = padCalendar(element.fillingDate);
		});
		state.routeName = window.location.pathname;
		this.setState(state);
		this.setState({ caseDataArray: state.caseDataArray });
	}
	componentDidMount() {
		if (this.state.routeName === "/CustomCaseManagement") {
			this.setState({ enableCommission: true });
			this.getIndexList();
		}
		if (this.state.routeName === "/cases") {
			this.setState({ enableView: true });
		}
		if (this.state.routeName === "/CaseManagement") {
			this.setState({ enableCMView: true });
			this.getIndexList();
		}
		this.setState({
			isAdminToken:
				localStorage.getItem("isAdminToken") === "false" ? false : true
		});
		/*let check = localStorage.getItem('detailsPageUrl');
				if (check != null) {
						let checkDetailsPage = JSON.parse(localStorage.getItem('detailsPageUrl'));
						this.props.history.push(checkDetailsPage);
				}*/
	}
	handleDelete = caseId => {
		let url = "";
		if (this.state.enableCommission) {
			url = "/commissions/" + caseId.id;
		} else {
			url = "/cases/" + caseId.caseId;
		}
		axios
			.delete(apiUri + url)
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
					if (this.state.enableCommission) {
						this.props.requestPageOfCommission(
							this.props.currentPage,
							this.state.sortValue,
							this.state.sortOrder
						);
					} else if (this.state.routeName === "/CaseManagement") {
						this.props.requestPageOfAdminCases(
							this.props.currentPage,
							this.state.sortValue,
							this.state.sortOrder
						);
					} else {
						this.props.requestPageOfCases(
							this.props.currentPage,
							this.state.sortValue,
							this.state.sortOrder
						);
					}
					NotificationManager.success(json.data.statusMessage, "Success");
					this.setState({ openDelete: false, deleteModalData: {} });
				}
			})
			.catch(err => {
				NotificationManager.error(err);
				console.log(err);
			});
	};

	handleHide = caseId => {
		let url = "";
		if (this.state.enableCommission) {
			url = "/commissions/" + caseId.id;
		} else {
			url = "/cases/" + caseId.caseId + "/ban";
		}
		axios
			.put(apiUri + url)
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
					if (this.state.enableCommission) {
						this.props.requestPageOfCommission(
							this.props.currentPage,
							this.state.sortValue,
							this.state.sortOrder
						);
					} else if (this.state.routeName === "/CaseManagement") {
						this.props.requestPageOfAdminCases(
							this.props.currentPage,
							this.state.sortValue,
							this.state.sortOrder
						);
					} else {
						this.props.requestPageOfCases(
							this.props.currentPage,
							this.state.sortValue,
							this.state.sortOrder
						);
					}
					console.log(json.data);
					NotificationManager.success(json.data.statusMessage, "Success");
					this.setState({ openHide: false, hideModalData: {} });
				}
			})
			.catch(err => {
				NotificationManager.error(err);
				console.log(err);
			});
	};

	handleImport = (caseData) => {
		axios
			.post(apiUri +'/admin/storeAndGenerateRiskInputFile/' + caseData.caseId, {})
			.then(res => {
				if (res.status && res.status >= 200 && res.status < 300) {
					NotificationManager.success(res.data.statusMessage, "Request Accepted");
				} else {
					NotificationManager.error(res.data.statusMessage, "Failure");
				}
				
			})
			.catch(err => {
				console.log(err);
			});

	};

	handleCompanySec11 = (caseData) => {
		axios
			.post(apiUri +'/admin/runSec11/' + caseData.caseId, {})
			.then(res => {
				if (res.status && res.status >= 200 && res.status < 300) {
					NotificationManager.success(res.data.statusMessage, "Sec 11 Request Accepted");
				} else {
					NotificationManager.error(res.data.statusMessage, "Failure");
				}
				
			})
			.catch(err => {
				console.log(err);
			});
	};
	handleOnChange = (caseData, value, key) => {
		let state = this.state;
		if (key === "enabled") {
			this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
			if (value === "false") {
				state.EditCaseData["enabled"] = true;
			} else {
				state.EditCaseData["enabled"] = false;
			}
		} else if (key === "blockIssUpdates") {

			state.EditCaseData["blockIssUpdates"] = !state.EditCaseData["blockIssUpdates"];

		} else if (key === "importStatus") {
			state.EditCaseData["importStatus"] = !state.EditCaseData["importStatus"];

		} else if (
			key === "classPeriodStart" ||
			key === "classPeriodEnd" ||
			key === "nextTradingDay" ||
			key === "fillingDate"
		) {
			this.setState({ [key]: value, [key + "Error"]: "" });
			let d = value;
			//d.setTime( d.getTime() + d.getTimezoneOffset()*60*1000 );
			state.EditCaseData[key] = new Date(value).getTime();
			state.EditCaseData[key + "_UI"] =
				new Date(d).getFullYear() +
				"-" +
				("0" + (new Date(d).getMonth() + 1)).slice(-2) +
				"-" +
				("0" + new Date(d).getDate()).slice(-2);
		} else {
			this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
			state.EditCaseData[key] = value;
		}
		this.setState({ EditCaseData: state.EditCaseData });
		if (state.enableCommission) {
			
		} else if (this.state.routeName === "/CaseManagement") {
			
		} else {
			this.props.requestPageOfCases(
				this.props.currentPage,
				this.state.sortValue,
				this.state.sortOrder
			);
		}
	};

	handleOnNotesChange = (caseNotesData) => {
		
		this.setState({ txtCaseNotes: caseNotesData });

	}



	handleEnable = (caseData, value, key) => {
		let state = this.state;
		state.caseDataArray.forEach(element => {
			if (state.enableCommission) {
				if (element.id === caseData.id) {
					if (value === "false") {
						element["enabled"] = true;
					} else {
						element["enabled"] = false;
					}
					this.props.handleSaveStatus(element);
				}
			} else {
				if (element.caseId === caseData.caseId) {
					if (value === "false") {
						element["enabled"] = true;
					} else {
						element["enabled"] = false;
					}
					this.props.handleSaveStatus(element);
				}
			}
		});
	};
	componentDidCatch(error, errorInfo) {
		console.log("Error:", error, errorInfo);
	}

	handleEdit = (caseData, actionType, value) => {
		if(!this.state.amendClaimsList || this.state.amendClaimsList.length === 0) {
			this.getamendClaimsList();
		}
		if(!this.state.ruleTypeList || this.state.ruleTypeList.length === 0) {
			this.getRuleType();
		}
		if(!this.state.settlementStatusList || this.state.settlementStatusList.length === 0) {
			this.getSettlementStatus();
		}

		let state = this.state;
		state.caseDataArray.forEach(element => {
			if (state.enableCommission) {
				if (element.id === caseData.id) {
					element.enableEdit = true;
					element.classPeriodStart =
						new Date(element.classPeriodStart_UI).getTime() +
						new Date(element.classPeriodStart_UI).getTimezoneOffset() *
						60 *
						1000;
					element.classPeriodEnd =
						new Date(element.classPeriodEnd_UI).getTime() +
						new Date(element.classPeriodEnd_UI).getTimezoneOffset() * 60 * 1000;
					if (element.nextTradingDay_UI) {
						element.nextTradingDay =
							new Date(element.nextTradingDay_UI).getTime() +
							new Date(element.nextTradingDay_UI).getTimezoneOffset() * 60 * 1000;
					}
					if (element.fillingDate_UI) {
						element.fillingDate =
							new Date(element.fillingDate_UI).getTime() +
							new Date(element.fillingDate_UI).getTimezoneOffset() * 60 * 1000;
					}
				}
			} else {
				if (element.id === caseData.id) {
					element.enableEdit = true;
					element.classPeriodStart =
						new Date(element.classPeriodStart_UI).getTime() +
						new Date(element.classPeriodStart_UI).getTimezoneOffset() *
						60 *
						1000;
					element.classPeriodEnd =
						new Date(element.classPeriodEnd_UI).getTime() +
						new Date(element.classPeriodEnd_UI).getTimezoneOffset() * 60 * 1000;
					if(element.nextTradingDay) {
						element.nextTradingDay =
							new Date(element.nextTradingDay_UI).getTime() +
							new Date(element.nextTradingDay_UI).getTimezoneOffset() * 60 * 1000;
					}
					element.fillingDate =
						new Date(element.fillingDate_UI).getTime() +
						new Date(element.fillingDate_UI).getTimezoneOffset() * 60 * 1000;  
					
					if (actionType === "Duplicate" && element.amendClaims === caseData.amendClaims) {
						element.amendClaims = caseData.amendClaimsOrig + 1;
					}
					
				}
			}
		});
		
		if(actionType === "Duplicate") {
			state.heading = "Duplicate";
		} else {
			state.heading = "Update";
		}
		
		this.setState(state);

		this.setState({ EditCaseData: caseData, open: true });
	};

	handleNotes = (caseId) => {
		
		this.props.getCaseNotesById(caseId);

		this.setState({ caseNotesId: caseId, openCaseNotes: true, txtCaseNotes : null });

	};

	// Fetch and handle disclosure dates based on the provided caseId
	getDisclosureDates = (filedCase) => {
		// Send a GET request to the API to retrieve disclosure dates for the specified caseId
		let caseId = filedCase.caseId;
		if(filedCase.caseRuleTypeId === 3 ){
			
			axios
			.get(`${apiUri}/offering/case/${caseId}`)
			.then(res => {
				let datesArray = [];
				if(res && res.data && res.data.statusCode === 200) {
					res.data.content.forEach(element => {
						// Create an object to represent each disclosure date
						let obj = {};
						obj.caseId = caseId;
						obj.offeringId = element.offeringId;
						obj.offeringTypeId = element.offeringTypeId;
						obj.offeringPrice = element.offeringPrice;
						obj.offeringShares = element.offeringShares;
						// Convert the date elements into milliseconds
						if(element && element.offeringDate) {
							const date = element.offeringDate;
							obj.disclosureDate = new Date(date[0], date[1] - 1, date[2]).getTime();
						}
						datesArray.push(obj);
					});
				}
				// Use Set to remove duplicates from datesArray
				this.setState({
					disclosureDates : [...new Set(datesArray)],
					openSec11CalendarModal : true,
					selectedCaseId : caseId
				});
				
			})
			.catch(err => {
				console.log(err);
			});
			
		} else {
			axios
			.get(`${apiUri}/cases/${caseId}/disclosure`)
			.then(res => {
				let datesArray = [];
				if(res && res.data && res.data.statusCode === 200) {
					res.data.content.forEach(element => {
						// Create an object to represent each disclosure date
						let obj = {};
						obj.caseId = caseId;
						obj.disclosureId = element.disclosureId;
						// Convert the date elements into milliseconds
						const date = element.disclosureDate;
						obj.disclosureDate = new Date(date[0], date[1] - 1, date[2]).getTime();
						datesArray.push(obj);
					});
				}
				// Use Set to remove duplicates from datesArray
				this.setState({
					disclosureDates : [...new Set(datesArray)],
					openCalendarModal : true,
					selectedCaseId : caseId
				});
			})
			.catch(err => {
				console.log(err);
			});

		}
	}

	handleSaveCaseNotes = (caseNotesId, caseNotes) => {
		if (caseNotesId) {
			let state = this.state;
			let obj = {
				caseId: caseNotesId,
				caseNotes: state.txtCaseNotes
			};
			axios
			.put(apiUri + "/cases/"+caseNotesId+"/caseNotes", obj)
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
					NotificationManager.success(json.data.statusMessage, "Success");
					//this.setState({ caseNotesId: null, txtCaseNotes: null, openCaseNotes: false });
					this.onCloseModal();
				} else {
					NotificationManager.error(json.data.statusMessage, "Error");
				}
			})
			.catch(err => {
				NotificationManager.error(err, "Error");
				console.log(err);
			});
		}
	};

	onOpenModal = () => {
		this.setState({ open: true });
	};

	onCloseModal = () => {
		//this.props.txtCaseNotes = null;
		this.setState({ open: false, openDelete: false, openHide: false, openCaseNotes : false, txtCaseNotes: null, caseNotesId: null });

		this.resetErrorStat();
	};

	onOpenBlockModal = () => {
		this.setState({ openBlock: true });
	};

	onCloseBlockModal = () => {
		this.setState({ openBlock: false });

		this.resetErrorStat();
	};

	onCloseCommissionInfoModal = () => {
		this.setState({ CommissionInfo: false });
	};

	togglePopup(type, filledCase) {
		if(type === "severity" && this.props.firmSettings.severity) {
			if(filledCase.purchased) {
				this.props.goToCaseHandler(filledCase.caseId)	;
				return;
			}
		} else if(type === "risk" && this.props.firmSettings.risk ) {

			this.createRisk(filledCase.caseId);
			return;
		}

		this.setState({ ...this.state, popupType: type});
		this.onOpenBlockModal();
	}
	resetErrorStat = () => {
		this.setState({
			fillingNameError: "",
			classPeriodStartError: "",
			classPeriodEndError: "",
			nextTradingDayError: "",
			fillingDateError: "",
			tickerError: "",
			docketIdError: "",
			issCaseIdError: "",
			sicCodeError: "",
			cikError: "",
			marketError: "",
			docketNotesError:"",
			settlementValueError:"",
			caseFileError: "",
			indexListIdError:"",
			identifierError: ""
		});
	};

	handleChange = name => event => {
		this.setState({ ...state, [name]: event.target.checked });
	};

	handleSelectChange = (selectedOption) => {
		let state = this.state;
		this.setState({ "indexListId": selectedOption.value, "indexListIdError": "" });
		state.EditCaseData["indexListId"] = selectedOption.value;

	};

	setSelectDefault = (inValue) => {
		var getIndex = this.state.indexList.map(function (options) { return options.value; }).indexOf(inValue);

		return getIndex;
	};



	formatapprox_market_cap_loss = data => {
		if (data) {
			data = data / 1000;
			data = Math.round(data);
			data = numberWithCommas(data);
			data = "$" + data;
			return data;
		} else {
			return "-";
		}
	};
	getRuleType() {
		axios
			.get(apiUri + "/cases/ruleType")
			.then(res => {
				this.setState({
					ruleTypeList: res.data.content
				});
			})
			.catch(err => {
				console.log(err);
			});
	}
	getSettlementStatus() {
		axios
			.get(apiUri + "/cases/settlementStatus")
			.then(res => {
				this.setState({
					settlementStatusList: res.data.content
				});
			})
			.catch(err => {
				console.log(err);
			});
	}
	getIndexList() {
		axios
			.get(apiUri + "/cases/getIndexList")
			.then(res => {
				if(res && res.data && res.data['content']) {
				this.setState({
					indexList: res.data['content']
				});
				}
			})
			.catch(err => {
				console.log(err);
			});
	}
	getamendClaimsList() {
		axios
			.get(apiUri + "/cases/amendClaims")
			.then(res => {
				this.setState({ amendClaimsList: res.data.content });
			})
			.catch(err => {
				console.log(err);
			});
	}

	getCommissionInfoBtId(id) {
		this.setState({
			CommissionInfo: true
		});
		this.props.getCommissionInfoBtId(id);
	}

	handleOpenCalendarModal = (data) => {
		this.setState({
			openCalendarModal : data
		});
	}	

	handleOpenSec11CalendarModal = (data) => {
		this.setState({
			openSec11CalendarModal : data
		});
	}

	render() {
		let props = this.props;
		let state = this.state;

		return (
			<React.Fragment>
				<Modal
					open={this.state.openBlock}
					onClose={this.onCloseBlockModal}
					focusTrapped={true}
					styles={{ modal: {width: "60%", height: "60%", overflow: "auto" } }}
				>
					<div className="ModalWindow modaladd">
						<FaTimes className="closeicon" onClick={this.onCloseBlockModal} />
						<br />
						<div className="modalHeading"></div>
						<div className="NavDivider"></div>
					
						{this.state.popupType === "risk" ? <RiskToolDisclosure /> : <Disclosure />}
						<div className="NavDivider"></div>
						<div>
							<div className="NavDivider"></div>
							<ButtonHolder>
								<LeftSideButton
									onClick={evt => {
										window.open(
														"https://www.sarlit.com/contact-us", "_blank");
									}}
									hoverBorderColor="#83bed3"
									tabIndex="-1"
								>
									Contact Us
								</LeftSideButton>
							</ButtonHolder>
							<ButtonHolder>
								
							</ButtonHolder>
						</div>
					</div>
				</Modal>
				<Modal open={this.state.open} onClose={this.onCloseModal}>
					<div className="ModalWindow modaladd">
						<FaTimes className="closeicon" onClick={this.onCloseModal} />
						<h3 className="modalHeading">{state.heading + " Case"}</h3>
						<div className="NavDivider"></div>
						<table>
							<thead></thead>
							<tbody>
								<tr>
									<td className="modalTd">
										{state.enableCommission
											? "Commission Name:"
											: "Filing Name:"}
									</td>
									<td style={{ paddingTop: 16 }}>
										<input
											id="search"
											type="text"
											className="searchBox2"
											value={state.EditCaseData.fillingName || ""}
											placeholder=""
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"fillingName"
												);
											}}
										/>
										<span id="error-style">{this.state.fillingNameError}</span>
									</td>
								</tr>
								<tr>
									<td className="modalTd">Class Period Start Date</td>
									<td style={{ paddingTop: 16 }}>
										<DatePicker
											className="searchBox2"
											selected={state.EditCaseData.classPeriodStart || ""}
											onChange={evt =>
												this.handleOnChange(
													state.EditCaseData,
													evt,
													"classPeriodStart"
												)
											}
											dateFormat="yyyy-MM-dd"
										/>
										<span id="error-style">
											{this.state.classPeriodStartError}
										</span>
									</td>
								</tr>
								<tr>
									<td className="modalTd">Class Period End Date</td>
									<td style={{ paddingTop: 16 }}>
										<DatePicker
											className="searchBox2"
											selected={state.EditCaseData.classPeriodEnd || ""}
											onChange={evt =>
												this.handleOnChange(
													state.EditCaseData,
													evt,
													"classPeriodEnd"
												)
											}
											dateFormat="yyyy-MM-dd"
										/>
										<span id="error-style">
											{this.state.classPeriodEndError}
										</span>
									</td>
								</tr>
								<tr>
									<td className="modalTd">Next Trading Day</td>
									<td style={{ paddingTop: 16 }}>
										<DatePicker
											className="searchBox2"
											selected={state.EditCaseData.nextTradingDay || ""}
											onChange={evt =>
												this.handleOnChange(
													state.EditCaseData,
													evt,
													"nextTradingDay"
												)
											}
											dateFormat="yyyy-MM-dd"
										/>
										<span id="error-style">
											{this.state.nextTradingDayError}
										</span>
									</td>
								</tr>
								{!state.enableCommission ? (
									<tr>
										<td className="modalTd">
											{state.enableCommission ? "Commission" : "Filing"} Date:
										</td>
										<td style={{ paddingTop: 16 }}>
											<DatePicker
												className="searchBox2"
												selected={state.EditCaseData.fillingDate || ""}
												onChange={evt =>
													this.handleOnChange(
														state.EditCaseData,
														evt,
														"fillingDate"
													)
												}
												dateFormat="yyyy-MM-dd"
											/>
											<span id="error-style">
												{this.state.fillingDateError}
											</span>
										</td>
									</tr>
								) : null}
								<tr>
									<td className="modalTd">Ticker</td>
									<td style={{ paddingTop: 16 }}>
										<input
											type="text"
											className="searchBox2"
											onKeyPress={$event => allowAlphaNumeric($event)}
											value={state.EditCaseData.ticker || ""}
											placeholder=""
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"ticker"
												);
											}}
										/>
										<span id="error-style">{this.state.tickerError}</span>
									</td>
								</tr>
								 <tr>
								 <td className="modalTd">CapIQ Identifier</td>
									<td style={{ paddingTop: 16 }}>
										<input
											type="text"
											className="searchBox2"
											onKeyPress={$event => allowAlphaNumeric($event)}
											value={state.EditCaseData.identifier || ""}
											placeholder=""
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"identifier"
												);
											}}
										/>
										<span id="error-style">{this.state.identifierError}</span>
									</td>
								</tr>
								{!state.enableCommission ? (
									<tr>
										<td className="modalTd">Docket<br />Number:</td>
										<td style={{ paddingTop: 16 }}>
											<input
												type="text"
												className="searchBox2"
												value={state.EditCaseData.docketId || ""}
												placeholder=""
												onChange={evt => {
													this.handleOnChange(
														state.EditCaseData,
														evt.target.value,
														"docketId"
													);
												}}
											/>
											<span id="error-style">{this.state.docketIdError}</span>
										</td>
									</tr>
								) : null}
								{!state.enableCommission ? (
									<tr>
										<td className="modalTd">ISS Case ID:</td>
										<td style={{ paddingTop: 16 }}>
											<input
												type="text"
												className="searchBox2"
												value={state.EditCaseData.issCaseId || ""}
												placeholder=""
												onChange={evt => {
													this.handleOnChange(
														state.EditCaseData,
														evt.target.value,
														"issCaseId"
													);
												}}
											/>
											<span id="error-style">{this.state.issCaseIdError}</span>
										</td>
									</tr>
								) : null}
								<tr>
									<td className="modalTd">SIC Code</td>
									<td style={{ paddingTop: 16 }}>
										<input
											type="text"
											className="searchBox2"
											onKeyPress={$event => onlyNumeric($event)}
											value={state.EditCaseData.sicCode || ""}
											placeholder=""
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"sicCode"
												);
											}}
										/>
										<span id="error-style">{this.state.sicCodeError}</span>
									</td>
								</tr>
								<tr>
									<td className="modalTd">CIK Code</td>
									<td style={{ paddingTop: 16 }}>
										<input
											type="text"
											className="searchBox2"
											onKeyPress={$event => onlyNumeric($event)}
											value={state.EditCaseData.cik || ""}
											placeholder=""
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"cik"
												);
											}}
										/>
										<span id="error-style">{this.state.cikError}</span>
									</td>
								</tr>
								<tr>

									<td className="modalTd">Market</td>
									<td style={{ paddingTop: 16 }}>
										<input
											type="text"
											className="searchBox2"
											value={state.EditCaseData.market || ""}
											placeholder=""
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"market"
												);
											}}
										/>
										<span id="error-style">{this.state.marketError}</span>
									</td>
								</tr>
								<tr>
									<td className="modalTd">Docket Notes:</td>
									<td style={{ paddingTop: 16 }}>
										<input
											type="text"
											className="searchBox2"
											value={state.EditCaseData.docketNotes || ""}
											placeholder=""
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"docketNotes"
												);
											}}
										/>
										<span id="error-style">{this.state.docketNotesError}</span>
									</td>
								</tr>
								<tr>
									<td className="modalTd">Settlement Value</td>
									<td style={{ paddingTop: 16 }}>
										<input
											type="number"
											className="searchBox2"
											value={state.EditCaseData.settlementValue || ""}
											placeholder=""
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"settlementValue"
												);
											}}
										/>
										<span id="error-style">{this.state.settlementValueError}</span>
									</td>
								</tr>
								<tr>
									<td className="modalTd">Case File:</td>
									<td style={{ paddingTop: 16 }}>
										<input
											type="text"
											className="searchBox2"
											value={state.EditCaseData.caseFile || ""}
											placeholder=""
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"caseFile"
												);
											}}
										/>
										<span id="error-style">{this.state.caseFileError}</span>
									</td>
								</tr>
								<tr>
									<td className="modalTd">Force Import</td>
									<td
										style={{ paddingTop: 16, zIndex: 1 }}
										className="relativePos"
									>
										<input
											type="checkbox"
											className="amendSelect"
											checked={state.EditCaseData.importStatus}
											onChange={evt => {
											this.handleOnChange(
												state.EditCaseData,
												evt.target.value,
												"importStatus"
											);
										}}
										/>
									</td>
								</tr>

								<tr>
									<td className="modalTd">Block ISS </td>
									<td
										style={{ paddingTop: 16, zIndex: 1 }}
										className="relativePos"
									>
										<input
											type="checkbox"
											className="amendSelect"
											checked={state.EditCaseData.blockIssUpdates}
											onChange={evt => {
											this.handleOnChange(
												state.EditCaseData,
												evt.target.value,
												"blockIssUpdates"
											);
										}}
										/>
									</td>
								</tr>
								<tr>
									<td className="modalTd">Settlement Status</td>
									<td
										style={{ paddingTop: 16, zIndex: 1 }}
										className="relativePos"
									>
										<select
											style={{ width: "100%" }}
											className="amendSelect"
											value={state.EditCaseData.settlementStatusId || ""}
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"settlementStatusId"
												);
											}}
										>
											{this.state.settlementStatusList.map(res => {
												return (
													<option key={res.id} value={res.id}>
														{res.status}
													</option>
												);
											})}
										</select>
									</td>
								</tr>
								
								<tr>
									<td className="modalTd">Type </td>
									<td
										style={{ paddingTop: 16, zIndex: 1 }}
										className="relativePos"
									>
										<select
											style={{ width: "100%" }}
											className="amendSelect"
											value={state.EditCaseData.caseRuleTypeId || ""}
											onChange={evt => {
												this.handleOnChange(
													state.EditCaseData,
													evt.target.value,
													"caseRuleTypeId"
												);
											}}
										>
											{this.state.ruleTypeList.map(res => {
												return (
													<option key={res.id} value={res.id}>
														{res.caseRuleType}
													</option>
												);
											})}
										</select>
									</td>
								</tr>

								{!state.enableCommission ? (
									<tr>
										<td className="modalTd">Claim Life Cycle</td>
										<td
											style={{ paddingTop: 16, zIndex: 1 }}
											className="relativePos"
										>
											<select
												style={{ width: "100%" }}
												className="amendSelect"
												value={state.EditCaseData.amendClaims || ""}
												onChange={evt => {
													this.handleOnChange(
														state.EditCaseData,
														evt.target.value,
														"amendClaims"
													);
												}}
											>
												{this.state.amendClaimsList.map(res => {
													return (
														<option key={res.id} value={res.id}>
															{res.claimType}
														</option>
													);
												})}
											</select>
											<span id="error-style">{this.state.amendClaimsError}</span>
										</td>
									</tr>
								) : null}
								<tr>
									<td className="modalTd">Industry Index </td>
									<td
										style={{ paddingTop: 16, zIndex: 1, width: "60%", color: "black" }}
										className="relativePos"
									>
										<Select
											style={{ width: "100%", zIndex: 100, color: "black" }}
											width="100%"
											name="indexListId"
											defaultValue={state.indexList[this.setSelectDefault(state.EditCaseData.indexListId)]}
											onChange={this.handleSelectChange}
											options={state.indexList}

										/> 
										 <span id="error-style">{this.state.indexListIdError}</span>
									</td>
								</tr>
								{state.enableCommission ? (
									<tr>
										<td className="modalTd">Status</td>
										<td
											style={{ paddingTop: 16, zIndex: 1 }}
											className="relativePos"
										>
											<select
												style={{ width: "100%" }}
												className="statusSelect"
												value={state.EditCaseData.status || ""}
												onChange={evt => {
													this.handleOnChange(
														state.EditCaseData,
														evt.target.value,
														"status"
													);
												}}
											>
												<option value="SUBMITTED">SUBMITTED</option>
												<option value="REJECTED">REJECTED</option>
												<option value="PROCESSING">PROCESSING</option>
												<option value="COMPLETED">COMPLETED</option>
											</select>
										</td>
									</tr>
								) : null}
							</tbody>
						</table>
						<div className="btnHolder">
							<br />
							<button
								className="btn btnS"
								onClick={evt => {
									this.handleSaveCase(state.EditCaseData, state.heading);
								}}
							>
								Save
							</button>
							&nbsp; &nbsp;
							<button
								className="btn btnC"
								onClick={evt => {
									this.setState({ open: false, EditCaseData: {} });
									this.resetErrorStat();
								}}
							>
								Cancel
							</button>
						</div>
					</div>
				</Modal>
				<Modal
					open={this.state.openDelete}
					onClose={this.onCloseModal}
					className="deltemodal"
				>
					<div>
						<FaTimes className="deleteicon" onClick={this.onCloseModal} />
					</div>
					<div className="ModalWindow ModalDelete">
						<p style={{ textAlign: "center" }}>
							Are you sure you want to delete&nbsp;
							{state.deleteModalData.fillingName} case?
						</p>
						<div className="textCenter">
							<button
								className="btn btnS"
								onClick={evt => {
									this.handleDelete(state.deleteModalData);
								}}
							>
								Delete
							</button>
							&nbsp; &nbsp;
							<button
								className="btn btnC"
								onClick={evt => {
									this.setState({ openDelete: false, deleteModalData: {} });
								}}
							>
								Cancel
							</button>
						</div>
					</div>
				</Modal>
				<Modal
					open={this.state.openCaseNotes}
					onClose={this.onCloseModal}
					focusTrapped={true}
				>
					<div className="ModalWindow modaladd">
						<FaTimes
							className="closeicon"
							onClick={this.onCloseModal}
						/>
						<h3 className="modalHeading">SCA Database Management</h3>
						<div className="NavDivider"></div>
						<div id={"corrective-events-holder"}>
							 
							<div className="m-t-20">
								<div className={"commission-input-label"}>Notes</div>
								<textarea
									name="txtCaseNotes"
									tabIndex="-1"
									className={"commission-input"}
									value={state.txtCaseNotes ?state.txtCaseNotes:this.props.txtCaseNotes}
									cols={50}
									rows={5}
									placeholder={"Notes"}
									onChange={evt => {
												this.handleOnNotesChange(
													evt.target.value
												);
											}}
									
								/>
							</div>
							<div className="textCenter">
								<button
									className="btn btnS"
									onClick={evt => {
										this.handleSaveCaseNotes(state.caseNotesId);
									}}
								>
									Save
								</button>
								&nbsp; &nbsp;
								<button
									className="btn btnC"
									onClick={evt => {
										this.onCloseModal();
									}}
								>
									Cancel
								</button>
							</div>
						</div>
						<p />
					</div>
					<div className="NavDivider"></div>

				</Modal>
				{this.state.openCalendarModal &&
					<DisclosureDatesComponent
						openCalendarModal={this.state.openCalendarModal}
						disclosureDates={this.state.disclosureDates}
						caseId={this.state.selectedCaseId}
						handleOpenCalendarModal={this.handleOpenCalendarModal}
						getDisclosureDates={this.getDisclosureDates}
					></DisclosureDatesComponent>
				}
				{this.state.openSec11CalendarModal &&
					<Sec11DisclosureDatesComponent
						openSec11CalendarModal={this.state.openSec11CalendarModal}
						disclosureDates={this.state.disclosureDates}
						caseId={this.state.selectedCaseId}
						handleOpenSec11CalendarModal={this.handleOpenSec11CalendarModal}
						getDisclosureDates={this.getDisclosureDates}
					></Sec11DisclosureDatesComponent>
				}
				<Modal
					open={this.state.openHide}
					onClose={this.onCloseModal}
					className="deltemodal"
				>
					<div>
						<FaTimes className="deleteicon" onClick={this.onCloseModal} />
					</div>
					<div className="ModalWindow ModalDelete">
						<p style={{ textAlign: "center" }}>
							Are you sure you want to permanently delete&nbsp;
							{state.hideModalData.fillingName} case?
						</p>
						<div className="textCenter">
							<button
								className="btn btnS"
								onClick={evt => {
									this.handleHide(state.hideModalData);
								}}
							>
								Permanent Delete
							</button>
							&nbsp; &nbsp;
							<button
								className="btn btnC"
								onClick={evt => {
									this.setState({ openHide: false, hideModalData: {} });
								}}
							>
								Cancel
							</button>
						</div>
					</div>
				</Modal>

				{/* //  CommissionInfo model start */}
				<Modal
					open={this.state.CommissionInfo}
					onClose={this.onCloseCommissionInfoModal}
					focusTrapped={true}
				>
					<div className="ModalWindow modaladd">
						<FaTimes
							className="closeicon"
							onClick={this.onCloseCommissionInfoModal}
						/>
						<h3 className="modalHeading">Commission Information</h3>
						<div className="NavDivider"></div>
						<DisclosureModal
							type="DisclosureReadonly"
							createFormState={this.props.CommissionInfo}
						/>
						<div>
							<div className="NavDivider"></div>
						</div>
					</div>
				</Modal>

				{/* //  CommissionInfo model end */}

				<table className={"CaseSelectorTable"}>
					<thead>
						<tr className={"CaseSelectorHeaders"}>
							<th
								className={"CaseSelectorHeader"}
								style={{
									align: "left",
									
									textAlign: "left",
									paddingTop: "16px"
								}}
							>
								{state.enableCommission ? "Commission Name" : "Defendant Co."} 
								<span className={"sortingIconsHolderSpan"} >
									<div className={"sortingIconsHolder"}>
										<div>
											<FaChevronUp
												className={
													props.sortValue === "caseName" &&
														props.sortOrder === "asc"
														? "activeSortBtn"
														: "sortBtn"
												}
												onClick={() => props.handleSorting("caseName", "asc")}
											/>
										</div>
										<div>
											<FaChevronDown
												className={
													props.sortValue === "caseName" &&
														props.sortOrder === "desc"
														? "activeSortBtn"
														: "sortBtn"
												}
												onClick={() => props.handleSorting("caseName", "desc")}
											/>
										</div>
									</div>
								</span>
							</th>
							<th
								className={"CaseSelectorHeader"}
								style={{  width: "6%" }}
							>
								Ticker
								<span className={"sortingIconsHolderSpan"} >
									<div className={"sortingIconsHolder"}>
										<div>
											<FaChevronUp
												className={
													props.sortValue === "symbol" &&
														props.sortOrder === "asc"
														? "activeSortBtn"
														: "sortBtn"
												}
												onClick={() => props.handleSorting("symbol", "asc")}
											/>
										</div>
										<div>
											<FaChevronDown
												className={
													props.sortValue === "symbol" &&
														props.sortOrder === "desc"
														? "activeSortBtn"
														: "sortBtn"
												}
												onClick={() => props.handleSorting("symbol", "desc")}
											/>
										</div>
									</div>
								</span>
							</th>
							{this.state.enableView === true && (
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "7%" }}
								>
									Filing<br />Type
								</th>
							)}
							{!this.state.enableCommission && !this.state.enableView && (
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "7%" }}
								>
									Filing<br />Type
								</th>
							)}
							{!state.enableCommission && (
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "10%" }}
								>
									{state.enableCommission ? "Commission" : "Filing"} Date
									<span className={"sortingIconsHolderSpan"} >
										<div className={"sortingIconsHolder"}>
											<div>
												<FaChevronUp
													className={
														props.sortValue === "dateFiled" &&
															props.sortOrder === "asc"
															? "activeSortBtn"
															: "sortBtn"
													}
													onClick={() =>
														props.handleSorting("dateFiled", "asc")
													}
												/>
											</div>
											<div>
												<FaChevronDown
													className={
														props.sortValue === "dateFiled" &&
															props.sortOrder === "desc"
															? "activeSortBtn"
															: "sortBtn"
													}
													onClick={() =>
														props.handleSorting("dateFiled", "desc")
													}
												/>
											</div>
										</div>
									</span>
								</th>
							)}
							{!this.state.enableCommission && (
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "10%" }}
								>
									Docket<br />Number
									<span className={"sortingIconsHolderSpan"}>
										<div className={"sortingIconsHolder"}>
											<div>
												<FaChevronUp
													className={
														props.sortValue === "docketId" &&
															props.sortOrder === "asc"
															? "activeSortBtn"
															: "sortBtn"
													}
													onClick={() => props.handleSorting("docketId", "asc")}
												/>
											</div>
											<div>
												<FaChevronDown
													className={
														props.sortValue === "docketId" &&
															props.sortOrder === "desc"
															? "activeSortBtn"
															: "sortBtn"
													}
													onClick={() =>
														props.handleSorting("docketId", "desc")
													}
												/>
											</div>
										</div>
									</span>
								</th>
							)}
							{this.state.enableView === true && (
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "6%" }}
								>
									Claim Life Cycle
								</th>
							)}
							{this.state.enableView === true && this.state.isAdminToken === false &&(
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "6%" }}
								>
									Settlement Status
								</th>
							)}
							{!this.state.enableCommission && !this.state.enableView && (
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "7%" }}
								>
									Claim Life Cycle
								</th>
							)}
							{!this.state.enableCommission && this.state.isAdminToken === false && (
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "7%" }}
								>
									Settlement Status
								</th>
							)}
							<th
								className={"CaseSelectorHeader"}
								style={{  width: "10%" }}
							>
								Class Period <br /> Start Date
								<span className={"sortingIconsHolderSpan"} >
									<div className={"sortingIconsHolder"}>
										<div>
											<FaChevronUp
												className={
													props.sortValue === "classPeriodStart" &&
														props.sortOrder === "asc"
														? "activeSortBtn"
														: "sortBtn"
												}
												onClick={() =>
													props.handleSorting("classPeriodStart", "asc")
												}
											/>
										</div>
										<div>
											<FaChevronDown
												className={
													props.sortValue === "classPeriodStart" &&
														props.sortOrder === "desc"
														? "activeSortBtn"
														: "sortBtn"
												}
												onClick={() =>
													props.handleSorting("classPeriodStart", "desc")
												}
											/>
										</div>
									</div>
								</span>
							</th>
							<th
								className={"CaseSelectorHeader"}
								style={{  width: "10%" }}
							>
								Class Period <br /> End Date
								<span className={"sortingIconsHolderSpan"} >
									<div className={"sortingIconsHolder"}>
										<div>
											<FaChevronUp
												className={
													props.sortValue === "classPeriodEnd" &&
														props.sortOrder === "asc"
														? "activeSortBtn"
														: "sortBtn"
												}
												onClick={() =>
													props.handleSorting("classPeriodEnd", "asc")
												}
											/>
										</div>
										<div>
											<FaChevronDown
												className={
													props.sortValue === "classPeriodEnd" &&
														props.sortOrder === "desc"
														? "activeSortBtn"
														: "sortBtn"
												}
												onClick={() =>
													props.handleSorting("classPeriodEnd", "desc")
												}
											/>
										</div>
									</div>
								</span>
							</th>
							
							
							{this.state.enableView === true && (
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "14%" }}
								>
									Approx. Market Cap. Losses (000s)
								</th>
							)}
							{this.state.isAdminToken === false && (
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "13%", paddingRight:'3px' }}
								>
									Approx. Market Cap. Losses (000s)
								</th>
							)}
							{this.state.isAdminToken === false && (
								<th
									className={"CaseSelectorButtonHeader"}
									
								>
									Near Real-Time Risk Assessment
								</th>
							)}
							{this.state.enableCommission && (
								<th
									className={"CaseSelectorHeader"}
									style={{  width: "18%" }}
								>
									Status
									<span className={"sortingIconsHolderSpan"} >
										<div className={"sortingIconsHolder"}>
											<div>
												<FaChevronUp
													className={
														props.sortValue === "status" &&
															props.sortOrder === "asc"
															? "activeSortBtn"
															: "sortBtn"
													}
													onClick={() => props.handleSorting("status", "asc")}
												/>
											</div>
											<div>
												<FaChevronDown
													className={
														props.sortValue === "status" &&
															props.sortOrder === "desc"
															? "activeSortBtn"
															: "sortBtn"
													}
													onClick={() => props.handleSorting("status", "desc")}
												/>
											</div>
										</div>
									</span>
								</th>
							)}
							{this.state.isAdminToken === true &&
								this.state.enableView === false && (
									<th
										className={"CaseSelectorHeader"}
										style={{
											
											width: this.state.enableCommission ? "25%" : "21%"
										}}
									>
										Options
									</th>
								)}
						</tr>
					</thead>
					<tbody>
						{state.caseDataArray.map((filledCase, index) => (
							<React.Fragment key={index}>
								{this.state.isAdminToken === true ? (
									<tr key={filledCase.caseId}>
										<td
											className={
												state.className +
												"Admin" +
												(state.routeName === "/CaseManagement" ||
													state.routeName === "/cases" ||
													state.routeName === "/CustomCaseManagement"
													? " cursorPointer"
													: " ")
											}
											style={{ float: "left", textAlign: "left", width: "80%" }}
											onClick={() => this.goToCases(filledCase.caseId)}
										>
											{filledCase.fillingName}
										</td>
										<td className={state.className + "Admin"}>
											{filledCase.ticker}
										</td>
										{this.state.enableView === true && (
											<td className={state.className + "Admin"}>
												{filledCase.caseRuleType}
											</td>
										)}
										{!this.state.enableCommission && !this.state.enableView && (
											<td className={state.className + "Admin"}>
												{filledCase.caseRuleType}
											</td>
										)}
										{!state.enableCommission && (
											<td className={state.className + "Admin"}>
												{filledCase.fillingDate_UI}
											</td>
										)}
										{!this.state.enableCommission && (
											<td className={state.className + "Admin"}>
												{filledCase.docketId}
											</td>
										)}
										{this.state.enableView === true && (
											<td className={state.className + "Admin"}>
												{filledCase.amendClaimsType}
											</td>
										)}
										{!this.state.enableCommission && !this.state.enableView && (
											<td className={state.className + "Admin"}>
												{filledCase.amendClaimsType}
											</td>
										)}
										{this.state.enableView === true && (
											<td className={state.className + "Admin"}>
												{filledCase.settlementStatus}
											</td>
										)}
										<td className={state.className + "Admin"}>
											{filledCase.classPeriodStart_UI}
										</td>
										<td className={state.className + "Admin"}>
											{filledCase.classPeriodEnd_UI}
										</td>
										{!this.state.enableCommission &&
											this.state.enableView === true && (
												<td className={state.className + "AdminNumber"}>
													{this.formatapprox_market_cap_loss(
														filledCase.approxMarketCapLoss
													)}
												</td>
											)}
										{this.state.enableCommission && (
											<td className={state.className + "Admin"}>
												{filledCase.status}
											</td>
										)}
										{this.state.enableView === false && (
											<td className={state.className + "Admin"}>
												<label className="switch-container">
													<input
														ref="switch"
														value={filledCase.enabled}
														checked={filledCase.enabled}
														onChange={evt => {
															this.handleEnable(
																filledCase,
																evt.target.value,
																"enabled"
															);
														}}
														className="switch"
														type="checkbox"
													/>
													<div>
														<div></div>
													</div>
												</label>

												<FaEdit
													title="Edit"
													className="editBtn"
													onClick={() => this.handleEdit(filledCase, 'Edit')}
												/>

												{this.state.enableCommission?
													<FaInfoCircle
														title="Notes"
														className="editBtn"
														onClick={() =>
															this.getCommissionInfoBtId(filledCase.id)
														}
													/> 
													:
													<FaInfoCircle
														title="Notes"
														className="editBtn"
														 onClick={() => this.handleNotes(filledCase.caseId) }
													/>
												}
												{this.state.isAdminToken &&
												<FaCalendarAlt
													title="Disclosures"
													className="editBtn"
													onClick={() => this.getDisclosureDates(filledCase) }/>
												}
												<FaTrash
													title="Delete"
													className="editBtn"
													onClick={() => {
														this.setState({
															openDelete: true,
															deleteModalData: filledCase
														});
													}}
												/>
												{!this.state.enableCommission && (
													<FaBan
														title="Block ISS Updates"
														className="editBtn"
														onClick={() => {
															this.setState({
																openHide: true,
																hideModalData: filledCase
															});
														}}
													/>
												)}
												{!this.state.enableCommission && (
													<FaCopy
														title="Duplicate Case"
														className="editBtn"
														onClick={() => this.handleEdit(filledCase, 'Duplicate')}
													/>
												)}

												{this.state.enableCMView && (
													 <FaFileExport
														 title="Generate Input Files"
														 className="editBtn"
														 onClick={() => this.handleImport(filledCase)}
													 />
												)}
												{this.state.enableCMView && filledCase.caseRuleTypeId === 3 && (
													 <FaCloudUploadAlt
														title="Run Sec 11"
														className="editBtn"
														onClick={() => this.handleCompanySec11(filledCase)}
													/>
												)}
											</td>
										)}
									</tr>
								) : this.state.isAdminToken === false &&
									props.firmSettings &&
									props.firmSettings.commissionEnabled === true &&
									props.firmSettings.subscription === true ? (
											<tr onClick={(event) => event.target.nodeName === "BUTTON"? this.togglePopup('risk', filledCase) : this.togglePopup('severity', filledCase)}>
												<td
													className={state.className}
													style={{ float: "left", textAlign: "left", width: "80%" }}
												>
													{filledCase.fillingName}
												</td>
												<td className={state.className}>{filledCase.ticker}</td>
												<td className={state.className}>
													{filledCase.caseRuleType}
												</td>
												<td className={state.className}>
													{filledCase.fillingDate_UI}
												</td>
												<td className={state.className}>
													{filledCase.docketId}
												</td>
												<td className={state.className}>
													{filledCase.amendClaimsType}
												</td>
												<td className={state.className}>
													{filledCase.settlementStatus}
												</td>
												<td className={state.className}>
													{filledCase.classPeriodStart_UI}
												</td>
												<td className={state.className}>
													{filledCase.classPeriodEnd_UI}
												</td>
												<td className={state.className+"Number"}
												style={{  paddingRight:'10px' }}>
													{this.formatapprox_market_cap_loss(
														filledCase.approxMarketCapLoss
													)}
												</td>
												<td className={state.className + "Button"}>
													<button className="btn btnR">
														License <br />Risk Report
													</button>
												</td>
											</tr>
										) : (
											<tr onClick={(event) => event.target.nodeName === "BUTTON"? this.togglePopup('risk', filledCase) : this.togglePopup('severity', filledCase)}>
												<td
													className={state.className + "User"}
													style={{ float: "left", textAlign: "left", width: "80%" }}
												>
													{filledCase.fillingName}
												</td>
												<td className={state.className + "User"}>
													{filledCase.ticker}
												</td>
												<td className={state.className + "User"}>
													{filledCase.caseRuleType}
												</td>
												<td className={state.className + "User"}>
													{filledCase.fillingDate_UI}
												</td>
												<td className={state.className + "User"}>
													{filledCase.docketId}
												</td>
												<td className={state.className + "User"}>
													{filledCase.amendClaimsType}
												</td>
												<td className={state.className + "User"}>
													{filledCase.settlementStatus}
												</td>
												<td className={state.className + "User"}>
													{filledCase.classPeriodStart_UI}
												</td>
												<td className={state.className + "User"}>
													{filledCase.classPeriodEnd_UI}
												</td>
												<td className={state.className + "UserNumber"}>
													{filledCase.approxMarketCapLoss == null? <img src="/8digit.png" alt="Approx. Market Cap Losses" style={{ width: "100%" }} />: this.formatapprox_market_cap_loss(
														filledCase.approxMarketCapLoss
													)}
												</td>
												<td className={state.className + "Button"} >
													<button className="btn btnR" >
														License <br />Risk Report
													</button>
												</td>
											</tr>
										)}
							</React.Fragment>
						))}
					</tbody>
				</table>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		currentCases: state.cases.currentCases,
		currentPage: state.cases.currentPage,
		totalCases: state.cases.totalCases,
		totalPages: state.cases.totalPages,
		firmSettings: state.firmSettings,
		CommissionInfo: state.cases.CommissionInfo,
		txtCaseNotes: state.cases.txtCaseNotes
	};
};
const mapDispatchToProps = dispatch => {
	return {
		requestPageOfCases: (page, sortValue, sortOrder) =>
			dispatch(requestPageOfCases(page, sortValue, sortOrder)),
		requestPageOfAdminCases: (page, sortValue, sortOrder) =>
			dispatch(requestPageOfAdminCases(page, sortValue, sortOrder)),
		requestPageOfCommission: (page, sortValue, sortOrder) =>
			dispatch(requestPageOfCommission(page, sortValue, sortOrder)),
		editInput: caseData => {
			dispatch({ type: "LOAD_UPDATED_CASES", value: caseData });
		},
		getCommissionInfoBtId: id => dispatch(getCommissionInfoBtId(id))
		,
		getCaseNotesById: id => dispatch(getCaseNotesById(id))
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withRouter(CaseEntries));



// WEBPACK FOOTER //
// ./src/components/CaseSelector/CaseEntries/CaseEntries.js